import PropTypes from 'prop-types'
import React, { Component } from 'react'
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Responsive,
  Segment,
  Sidebar,
  Visibility,
} from 'semantic-ui-react'

import { Link } from '@reach/router';
import ResponsiveContainer from 'components/layout/PageComponents';

import Process from 'assets/images/process.png';

/* eslint-disable react/no-multi-comp */
const HomepageHeading = ({ mobile }) => (
  <Container text>
    <Header
      as='h1'
      content='Malaysia Future Flood Explorer'
      inverted
      style={{
        fontSize: mobile ? '2em' : '3em',
        fontWeight: 'normal',
        marginBottom: 0,
        marginTop: mobile ? '1.5em' : '2em',
      }}
    />
    <Header
      as='h2'
      content={<Button primary size='huge' as={Link} to='/map-explorer'>Start Exploring</Button>}
      inverted
      style={{
        fontSize: mobile ? '1.5em' : '1.7em',
        fontWeight: 'normal',
        marginTop: mobile ? '0.5em' : '1.5em',
      }}
    />
  </Container>
)

HomepageHeading.propTypes = {
  mobile: PropTypes.bool,
}


const HomepageLayout = (props) => (
  <ResponsiveContainer
    DesktopHeading={<HomepageHeading/>}
    MobileHeading={<HomepageHeading mobile/>}
    currentPage="home">
    <Segment style={{ padding: '0em' }} vertical>
      <Grid  container columns='equal' stackable verticalAlign='middle'>
        <Grid.Row textAlign='center'>
          <Grid.Column style={{ paddingBottom: '4em', paddingTop: '4em' }}>
            <p style={{ fontSize: '1.33em' }}>         
            The Malaysia Future Flood Explorer (FFE) was first developed by Sayers and Partners in collaboration
            with UK and Malaysian partners to provide a probabilistic assessment of flood risks across Malaysia 
            today and in the future using a consistent data and modelling framework.</p>
            <p style={{ fontSize: '1.33em' }}>
            The summary results can be explored here – for present day and future flood risks.
            </p>
          </Grid.Column>
          <Grid.Column style={{ paddingBottom: '4em', paddingTop: '4em' }}>
            <p style={{ fontSize: '1.33em' }}>
              <Image size="big" src={Process} />
            </p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>

    <Segment style={{ padding: '3em 0em' }} vertical>
      <Grid container stackable verticalAlign='middle'>
        <Grid.Row>
          <Grid.Column textAlign='center'>
            <Button size='huge' as={Link} to="/map-explorer">
              Start Exploring
              <Icon name='right arrow' />
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <Container text>
        <Divider
          as='h4'
          className='header'
          horizontal
          style={{ marginTop: '7em', marginBottom: '3em', textTransform: 'uppercase' }}
        >
          <a href='#'>Partners</a>
        </Divider>
        <p style={{ fontSize: '1.33em' }}>
        This dashboard has been developed with funding support from the UK Newton funds and national Malaysia
        funding bodies that include:
        </p>

        <Grid container stackable verticalAlign='middle' textAlign='center'>
          <Grid.Row>
              <Grid.Column width={4}>
                  <Image src="/assets/images/logos/ministry_of_higher_education.png" height="80px" />
              </Grid.Column>
              <Grid.Column width={4}>
                  <Image src="/assets/images/logos/newton-ungku-omar-master-website.jpg" />
              </Grid.Column>
              <Grid.Column width={4}>
                  <Image src="/assets/images/logos/ESRC logo.png" />
              </Grid.Column>
          </Grid.Row>

          <Grid.Row>
              <Grid.Column width={4}>
                  <Image src="/assets/images/logos/NERC logo.png" />
              </Grid.Column>
              <Grid.Column width={4}>
                  <Image src="/assets/images/logos/sayers-and-partners.png" />
              </Grid.Column>
              <Grid.Column width={4}>
                  <Image src="/assets/images/logos/ceh.png" />
              </Grid.Column>
          </Grid.Row>

          <Grid.Row>
              <Grid.Column width={4}>
                  <Image src="/assets/images/logos/logoupm.png" />
              </Grid.Column>
              <Grid.Column width={4}>
                  <Image src="/assets/images/logos/logouum-small.png" />
              </Grid.Column>
              <Grid.Column width={4}>
                  <Image src="/assets/images/logos/LogoUKMWatan.png" />
              </Grid.Column>
          </Grid.Row>
      </Grid>

      </Container>
    </Segment>
    <Segment inverted vertical style={{ padding: '5em 0em' }}>
      <Container>
        <Grid divided inverted stackable>
          <Grid.Row>
            <Grid.Column width={3} />
            <Grid.Column width={3}>
              <Header inverted as='h4' content='About' />
              <List link inverted>
                <List.Item as='a'>Sitemap</List.Item>
                <List.Item as='a' href="http://http://www.sayersandpartners.co.uk/contact-us.html">Contact Us</List.Item>
              </List>
            </Grid.Column>
            <Grid.Column width={7}>
              <Header as='h4' inverted>
                Malaysia future flood explorer
              </Header>
              <p>
              A probabilistic assessment of flood risks from all sources across the Malaysian Peninsular today and in the future
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>
  </ResponsiveContainer>
)
export default HomepageLayout